module.exports = __webpack_public_path__ + "img/抽奖-转盘底纹.94924ec7.png";